document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("newsletterModal");
    const closeBtn = document.querySelector("#newsletterModal .close-modal");
    const newsletterModalShownKey = "newsletterModalShown";

    if (modal === null || closeBtn === null) return;

    // when reload reset the sessionStorage value
    const navType = window.performance && window.performance.getEntriesByType("navigation")[0]?.type;
    if (navType === "reload") {
        sessionStorage.removeItem(newsletterModalShownKey);
    }

    if (!sessionStorage.getItem(newsletterModalShownKey)) {
      modal.style.display = "block";
      sessionStorage.setItem(newsletterModalShownKey, "true");
    }

    // Close button
    closeBtn.addEventListener("click", function () {
        modal.style.display = "none";
    });

    // Close by clicking outside
    window.onclick = function (event) {
        if (event.target === modal) {
            modal.style.display = "none";
        }
    };
});
